module.exports = __webpack_public_path__ + "img/tikle.40e64e42.png";